module.exports = __webpack_public_path__ + "assets/img/advantages3.b75529ef.png";